module.exports = function() {
  return new Worker(__webpack_public_path__ + "afb87bf65cd47bacd5ad.worker.js");
};